import { ISelectOption } from "core-integration/src/store";
import { FilterChip } from "plos/src/components/Chip";
import { PopoverSelect } from "plos/src/components/PopoverSelects";
import { ListBoxItem, Selection } from "react-aria-components";
import { useTranslation } from "react-i18next";
import styles from "../../../FilterPopovers/filterPopover.module.css";
import { PriceChangeProgressFilter } from "../utils";

interface ProgressFilterPopoverProps {
  value: PriceChangeProgressFilter;
  onChange: (value: PriceChangeProgressFilter) => void;
  showLockedOption: boolean;
}

const ProgressFilterPopover = ({
  value,
  onChange,
  showLockedOption,
}: ProgressFilterPopoverProps) => {
  const { t } = useTranslation("priceChanges");

  const options: (ISelectOption & { value: PriceChangeProgressFilter })[] = [
    {
      value: "riseAndDrop",
      label: t("progressFilterPopover.riseAndDrop", "Rise & drop"),
    },
    { value: "rise", label: t("progressFilterPopover.rise", "Rise") },
    { value: "drop", label: t("progressFilterPopover.drop", "Drop") },
    ...(showLockedOption
      ? [
          {
            value: "locked" as const,
            label: t("progressFilterPopover.locked", "Locked"),
          },
        ]
      : []),
  ];

  const selectedOption = options.find((o) => o.value === value) ?? options[0];

  const handleChange = (keys: Selection) => {
    const key = Array.from(keys)[0] as PriceChangeProgressFilter | undefined;
    onChange(key ?? "riseAndDrop");
  };

  return (
    <PopoverSelect
      popoverTrigger={
        <FilterChip
          label={t("progressFilterPopover.filterBy", "Progress")}
          selectedOption={[selectedOption]}
          isModified={value !== "riseAndDrop"}
        />
      }
      selectedKey={value}
      handleOnChange={handleChange}
    >
      {options.map(({ value: optionValue, label }) => (
        <ListBoxItem
          key={optionValue}
          id={optionValue}
          data-selected={optionValue === selectedOption.value}
          className={styles.popoverListItem}
          textValue={label}
        >
          {label}
        </ListBoxItem>
      ))}
    </PopoverSelect>
  );
};

export default ProgressFilterPopover;
